import { render, staticRenderFns } from "./PaymentPeriods.vue?vue&type=template&id=0ea5bdf0&"
import script from "./PaymentPeriods.vue?vue&type=script&lang=js&"
export * from "./PaymentPeriods.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPeriods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports